<ng-template #formModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Phone number report</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <app-phone-reports-form [model]="model" (afterSave)="onAfterSave($event)"></app-phone-reports-form>
</ng-template>
